import { render, staticRenderFns } from "./TermsOfServiceView.vue?vue&type=template&id=f1e1a134&"
import script from "./TermsOfServiceView.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServiceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports